import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
 
import { TourneeModel } from '../models/tournee.model';
import { DataService } from '../services/data/data.service';
import { SaleService } from '../services/sale/sale.service';
 
@Injectable({
  providedIn: 'root',
})

export class TourneesByProducerResolverService implements Resolve<TourneeModel[]> {

  constructor(private dataService: DataService, private saleService: SaleService) {
  }
 
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<TourneeModel[]> {
    let id = route.paramMap.get('profileId');
    const items = await firstValueFrom(this.dataService.getTourneesByProducer(id))
    this.saleService.convertSalesToDatePlaceSystem(items)
    await this.saleService.cleanDirtySales(items);
    return items;
  }
}